import { useApp } from '../context.js';
import TagPicker from './TagPicker.jsx';
import { suggestCategories } from '../lib/categories.js';

export default function EditRestaurantModal() {
    const { editForm, editingRestaurant, saveEditedRestaurant, setEditForm, setEditingRestaurant } = useApp();
    if (!editingRestaurant) return null;
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={() => setEditingRestaurant(null)}>
            <div className="bg-white apple-card rounded-3xl p-6 max-w-md w-full shadow-2xl max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">✏️ Edit Restaurant</h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Name:</label>
                        <input
                            type="text"
                            value={editForm.name}
                            onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors"
                            placeholder="Restaurant name"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Address:</label>
                        <input
                            type="text"
                            value={editForm.address}
                            onChange={(e) => setEditForm({...editForm, address: e.target.value})}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors"
                            placeholder="Address (optional)"
                        />
                    </div>
                    <TagPicker
                        value={{ cuisine: editForm.cuisine || [], vibe: editForm.vibe || [] }}
                        suggested={suggestCategories(editForm.name, editingRestaurant.placeTypes || [])}
                        onChange={(tags) => setEditForm({ ...editForm, ...tags })}
                    />
                    <div className="flex gap-2 pt-2">
                        <button
                            onClick={() => setEditingRestaurant(null)}
                            className="flex-1 bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={saveEditedRestaurant}
                            disabled={!editForm.name.trim()}
                            className={`flex-1 px-4 py-3 rounded-xl font-semibold apple-button ${
                                editForm.name.trim()
                                    ? 'bg-gradient-to-r from-blue-400 to-blue-500 text-white'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
